import { render, staticRenderFns } from "./home_component.vue?vue&type=template&id=8cb4bc5c&scoped=true&"
import script from "./home_component.vue?vue&type=script&lang=js&"
export * from "./home_component.vue?vue&type=script&lang=js&"
import style0 from "./home_component.vue?vue&type=style&index=0&id=8cb4bc5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb4bc5c",
  null
  
)

export default component.exports